<template>
    <v-card
        class="mx-auto"
        max-width="500"
        outlined
        elevation="2"
    >
        <v-card-title class="justify-center">{{ $t('views.auth.confirm_email.confirm_email') }}</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="text-center" v-if="verificationEmailSending">
            {{ $t('views.auth.confirm_email.sending_email') }}
            <v-progress-linear
                indeterminate
                color="primary"
                class="mb-5"
            ></v-progress-linear>
        </v-card-text>

        <v-card-text v-else class="text-center">
            <v-alert
                outlined
                type="success"
            >
                {{ $t('views.auth.confirm_email.instructions') }}
            </v-alert>
        </v-card-text>

        <v-card-text class="text-center" v-if="!verificationEmailSending">
            {{ $t('views.auth.confirm_email.no_email_instructions') }}
            <v-btn
                small
                text
                rounded
                @click="sendVerificationEmail"
            >{{ $t('views.auth.confirm_email.resend_email') }}</v-btn>
        </v-card-text>

        <v-card-text class="text-center">
            <a href="javascript:void(0)" @click="logout">{{ $t('views.auth.confirm_email.logout') }}</a>
        </v-card-text>
    </v-card>
</template>

<script>
import {Auth} from "../../modules/utils";

export default {
        name: "ConfirmEmail",

        data() {
            return {
                verificationEmailSending: false,
                loggingOut: false,
            };
        },

        methods: {
            sendVerificationEmail: function () {
                if(this.verificationEmailSending) {
                    return;
                }

                this.verificationEmailSending = true;

                this.$store.dispatch("sendVerificationEmail")
                    .then(response => {
                        if(response.status !== 202) {
                            this.$store.commit(
                                "showSnackbarError",
                                this.$t('views.auth.confirm_email.sending_email_failed')
                            );
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.verificationEmailSending = false;
                });
            },

            logout: function () {
                if(this.loggingOut) {
                    return;
                }

                this.loggingOut = true;

                this.$store.dispatch('logout')
                    .then(response => {
                        if(response.status !== 204) {
                            this.$store.commit(
                                "showSnackbarError",
                                this.$t('views.auth.confirm_email.logout_failed')
                            );
                            return;
                        }

                        Auth.clear();
                        //Auth.redirectToLogin();
                        this.$router.push({name: 'login'}).catch(() => {});
                    })
                    .catch(error => {})
                    .then(() => {
                        this.loggingOut = false;
                });
            },
        },
    }
</script>

<style scoped>

</style>
